export default class Header {
  constructor(elements) {
    this.elements = elements;
    this.options = {
      treshold: this.elements.dataset.treshold,
      alwaysShow: 1,
    };
    this.scrollPosition = 0;
    this.lastScrollPosition = 0;
    this.html = document.documentElement;

    this.init();
    this.initAlwaysShow();
    console.log("constructor");
    this.initNavMobile();
  }
  init() {
    this.setOptions();
    window.addEventListener("scroll", this.onScroll.bind(this));
  }
  initAlwaysShow() {
    if (this.elements.hasAttribute("data-always-show")) {
      this.options.alwaysShow = 0;
    } else {
      this.options.alwaysShow = 1;
    }
  }
  setOptions() {}
  onScroll() {
    this.lastScrollPosition = this.scrollPosition;
    this.scrollPosition = document.scrollingElement.scrollTop;
    this.setHeaderState();
  }
  setHeaderState() {
    if (
      this.scrollPosition >
      document.scrollingElement.scrollHeight *
        this.options.treshold *
        this.options.alwaysShow
    ) {
      this.html.classList.add("header-is-hidden");
    } else if (this.scrollPosition < this.lastScrollPosition) {
      this.html.classList.remove("header-is-hidden");
    }
  }

  initNavMobile() {
    const toggle = this.elements.querySelector(".js-toggle");
    toggle.addEventListener("click", this.onToggleNav.bind(this));
  }

  onToggleNav() {
    document.documentElement.classList.toggle("nav-is-active");
  }
}
